import { Component } from '@angular/core';
import { DialogContentBase } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-modal-popup-impl',
  templateUrl: './modal-popup-impl.component.html',
  styleUrls: ['./modal-popup-impl.component.scss']
})
export class ModalPopupImplComponent extends DialogContentBase {

  public close() {
    this.dialog.close();
  }

  public leave() {
    this.dialog.close({ primary: true });
    return true;
  }

  public stay() {
    this.dialog.close();
    return false;
  }

}
